import { configureStore } from "@reduxjs/toolkit";
import applyCouponCodeReducer from "./slice/applyCouponCodeSlice";
import calculateRechargeAmountReducer from "./slice/calculateRechargeAmountSlice";
import createCashPaymentReducer from "./slice/createCashPaymentSlice";
import customerRechargeUiReducer from "./slice/customerRechargeUiSlice";
import fetchCashRechargeDetailsReducer from "./slice/fetchCashRechargeDetailsSlice";
import fetchCustomerListReducer from "./slice/fetchCustomerListSlice";
import fetchPlantsReducer from "./slice/fetchPlantsSlice";
import fetchRealtimeBalanceReducer from "./slice/fetchRealtimeBalanceSlice";
import fetchTariffPlanChangeDetailsReducer from "./slice/fetchTariffPlanChangeDetailsSlice";
import permissionReducer from "./slice/permissionSlice";
import sidebarMenuReducer from "./slice/sidebarMenuSlice";
import userReducer from "./slice/userSlice";

export const store = configureStore({
  reducer: {
    user: userReducer,
    permissions: permissionReducer,
    sidebarMenu: sidebarMenuReducer,
    customerRechargeUi: customerRechargeUiReducer,
    applyCouponCode: applyCouponCodeReducer,
    fetchPlants: fetchPlantsReducer,
    fetchCustomerList: fetchCustomerListReducer,
    createCashPayment: createCashPaymentReducer,
    calculateRechargeAmount: calculateRechargeAmountReducer,
    fetchCashRechargeDetails: fetchCashRechargeDetailsReducer,
    fetchRealtimeBalance: fetchRealtimeBalanceReducer,
    fetchTariffPlanChangeDetails: fetchTariffPlanChangeDetailsReducer,
  },
});

export type StoreState = ReturnType<typeof store.getState>;
